/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './tee-tabs.stache';
import _ from 'lodash';
import can from 'can';
import dtm from 'scripts/services/dtm';

function getRoundQuery(round) {
    if (round.round.number) {
        return 'round-' + round.round.number;
    } else {
        return round.round.name
            .split(' ')
            .reverse()
            .map((part) => part.toLowerCase())
            .join('-');
    }
}

Component.extend({
    tag: 'tee-tabs',
    template,
    viewModel: {
        onTabChange(event) {
            this.rounds.forEach((item) => {
                const roundName = item.round.name;
                if (roundName === event.payload.value) {
                    const roundQuery = getRoundQuery(item);
                    this.attr('currentRound', item);
                    can.route.attr({ round: roundQuery });
                }
            });
            this.attr('searchValue', '');
        },
    },
    events: {
        inserted(element) {
            const rounds = this.viewModel.attr('rounds');
            let defaultRoundIndex = parseInt(
                this.viewModel.attr('defaultRoundIndex'),
            );
            if (isNaN(defaultRoundIndex)) {
                defaultRoundIndex = rounds.length - 1;
            }

            can.route(':round', { round: '' });
            can.route.bind('round', (ev, newVal) => {
                this.setActiveRound(newVal);
            });
            can.route.ready();

            if (!this.viewModel.attr('currentRound')) {
                const currentRound = rounds[defaultRoundIndex];
                this.viewModel.attr('currentRound', currentRound);
            }
            dtm.trackTeeTimesTab(
                'teeTimesTab',
                this.viewModel.attr('currentRound.round.name'),
            );

            this.viewModel.bind('defaultRoundIndex', (ev, newVal) => {
                if (!_.isNil(newVal)) {
                    can.route.attr({
                        round: getRoundQuery(
                            this.viewModel.attr(`rounds.${newVal}`),
                        ),
                    });
                }
            });
        },
        setActiveRound(roundQuery) {
            const round = this.getRoundByRoundQuery(roundQuery);
            if (round) {
                this.viewModel.attr('currentRound', round);
            }
        },

        getRoundByRoundQuery(roundQuery) {
            let round = null;
            this.viewModel.attr('rounds').forEach((item) => {
                const itemRoundQuery = getRoundQuery(item);
                if (roundQuery === itemRoundQuery) {
                    round = item;
                }
            });
            return round;
        },
    },
});
